import AdvancedController from "./advanced-controller"

export default class SearchFieldController extends AdvancedController {

  static targets = ['searchField' ];

  onSearchClear(e) {
    e.preventDefault();
    this.searchFieldTarget.value = ""
    this.searchFieldTarget.focus()
  }

}
